
const initialstate = {
    departments: null,
    skillset:null,
    searchByDeptName:'',
    searchByDeptId:'',
    page: 1,
  };
  export const skillSetMatrix = (state = initialstate, { type, payload }) => {
    switch (type) {
      case "GET_DEPARTMENTS": {
        return {
          ...state,
          loading: false,
          departments: payload,
        };
      }
      case "GET_SKILLSET": {
        return {
          ...state,
          
          skillset: payload,
          loading: false,
        };
      }
      case "SET_SEARCH_DEPT_NAME": {
        return {
          ...state,
          loading: false,
          searchByDeptName: payload,
          page: 1,
        };
      }
      case "SET_SEARCH_DEPT_ID": {
        return {
          ...state,
          loading: false,
          searchByDeptId: payload,
          page: 1,
        };
      }
      default: {
        return { ...state };
      }
    }
  };
  